import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Denounce } from '../../../core/models/denounce.model';
import { Component, Inject, OnInit } from '@angular/core';
import { UserService } from '../../../core/services/user.service';
import { UtilsService } from '../../../core/services/utils.service';

@Component({
	selector: 'app-read-more',
	templateUrl: './read-more.component.html',
	styleUrls: ['./read-more.component.scss'],
})
export class ReadMoreComponent implements OnInit {
	denounce: Denounce;
	depoimento: String;
	public loading = true;

	private denounceId: string;
	private readMoreWrapper = false;
	private menuActions: boolean;
	private confirmedUser: boolean;

	user = {
		gender: '',
		age: 0,
	};

	constructor(
		public utils: UtilsService,
		private userService: UserService,
		public dialogRef: MatDialogRef<ReadMoreComponent>,
		@Inject(MAT_DIALOG_DATA) public data: unknown
	) {
		this.denounce = this.data['denounce'];
	}

	ngOnInit(): any {
	}

	closeModal(): void {
		this.dialogRef.close();
	}

	getUser(id: string): void {
		this.userService.getUser(id).subscribe(
			(user) => {
				if (user.status !== 400) {
					this.user.gender = this.utils.translateGender(user.gender);
					const data = new Date();
					const birth = new Date(user.birthdate);

					birth.setHours(birth.getHours() + 3);
					this.user.age = data.getFullYear() - birth.getFullYear();

					if (user === 404) {
						this.confirmedUser = false;
						this.loading = false;
					} else {
						this.confirmedUser = true;
						this.loading = false;
					}
				}
			},
		)
	}

}
